export default "__VITE_ASSET__59edca84__"